<div class="dialog-header">
  <h2>Edit Subscription Benefits</h2>
  <button class="x-btn" (click)="close()">&#10005;</button>
</div>

<div class="dialog-body">
  <div class="form-group" *ngFor="let b of benefits">
    <label>{{ b.label }}</label>
    <input type="number" [(ngModel)]="b.value" />
  </div>
</div>

<div class="dialog-footer">
  <button class="close-btn" (click)="close()">Close</button>
  <button class="submit-btn" (click)="submit()">Submit</button>
</div>
